import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { FindAHomeNoLocationsStyles } from './FindAHomeNoLocations.styled';
import SectionLink from '@components/Shared/SectionLink/SectionLink';

const FindAHomeNoLocations = ({ onExpandRange, postalCode }) => {
  const handleClick = () => {
    if (onExpandRange) {
      onExpandRange();
    }
  };

  return (
    <FindAHomeNoLocationsStyles>
      <div className="no-locations-container">
        {!postalCode ? (
          <h3>Please provide a zip code.</h3>
        ) : (
          <h3>Oops! This page cannot be viewed.</h3>
        )}
        {!postalCode ? (
          <p className="intro">
            <a
              href="#"
              tabIndex="0"
              className="expand"
              onClick={(e) => {
                handleClick();
                e.preventDefault();
              }}
            >
              {' '}
              Add your zip code{' '}
            </a>
            to assist with your home search.
          </p>
        ) : (
          <p className="intro">
            Please explore
            <SectionLink
              to="/studio/"
              className="expand"
              internalLink={true}
              addSiteUrl={false}
            >
              {' '}
              information about our homes.
            </SectionLink>
          </p>
        )}

        <div className="illustration-container">
          <Image
            className="illustration"
            src="/public-assets/images/no-homes-illustration.svg"
            alt="No Homes Illustration"
            fill
          />
        </div>
      </div>
    </FindAHomeNoLocationsStyles>
  );
};

FindAHomeNoLocations.propTypes = {
  onExpandRange: PropTypes.func.isRequired,
  postalCode: PropTypes.string,
};

export default FindAHomeNoLocations;
